export default {
  sm: `
    Planting
    2.25 million 
    trees
  `,
  md: `
    Planting
    2.25 million
    trees
  `,
};
